<template>
  <div class="avatar-box" :class="shape">
    <el-image :src="avatarSrc" class="avatar">
      <div slot="error" class="image-slot">
        <img :src="defaultSrc" />
      </div>
    </el-image>
  </div>
</template>

<script>
import userAvatar from "../assets/image/cl_user_avatar.png";
import adminAvatar from "../assets/image/cl_admin_avatar.png";
export default {
  name: "user-avatar",
  props: {
    src: String,
    userType: Number,
    shape: {
      type: String,
      default: "circle",
    },
  },
  computed: {
    avatarSrc: function () {
      let src = this.src;
      if (/^(https:|http:|\/\/)/.test(src)) {
        return src;
      } else {
        return this.defaultSrc;
      }
    },
    defaultSrc: function () {
      // return 'http://148.70.221.198/pc/image/cl_user_avatar.png'
      if (this.userType == 2) {
        return adminAvatar;
      } else {
        return userAvatar;
      }
    },
  },
};
</script>

<style>
.avatar-box {
  width: 50px;
  height: 50px;
  display: flex;
  align-items: center;
}

.avatar-box.terse {
  width: 40px;
  height: 40px;
}

.avatar-box.comment {
  width: 40px;
  height: 40px;
}

.avatar-box.chat-terse {
  width: 35px;
  height: 35px;
}

.avatar-box.fans-avtar {
  width: 60px;
  height: 60px;
}

.avatar {
  width: 100%;
  height: 100%;
}

.avatar img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 50%;
}
</style>
